export class GraficoDispersionesDia {
    dispersionesLiquidadas: number;
    dispersionesRechazadas: number;
    dispersionesProcesando: number;
    dispersionesTotales: number;
    fecha: string;
}